//Reducer State Solicitud Promocion
import {reducer as Auth, State as AuthState} from './Seguridad/auth.Reducer';
import { reducer as Menus, State as MenusState } from './Administracion/menus.reducer';


export interface State{
    Auth: AuthState;
    Menus: MenusState;
    
}

export const reducers = {
    Auth,
    Menus
}